export default "__VITE_ASSET__bb746804__"